export const layout_names = {
  authorization: 'authorization'
}